export enum AddressType {
  Licence = 1,
  Pickup = 2,
  Billing = 3,
}
